        
export const Facet = () => {

    /**
     * Replace fSelect arrow with reset button when selection is active
     * Applies to ALL fSelect facets automatically
     * Add this to your theme's functions.php or a custom plugin
     */
    document.addEventListener('facetwp-loaded', function () {
        // Get all fSelect facets
        const fSelectFacets = document.querySelectorAll('.facetwp-type-fselect');

        fSelectFacets.forEach(function (facetEl) {
            // Extract facet name from class (e.g., 'facetwp-facet-resource_type' -> 'resource_type')
            const facetClass = Array.from(facetEl.classList).find((cls) => cls.startsWith('facetwp-facet-'));
            if (!facetClass) return;

            const facetName = facetClass.replace('facetwp-facet-', '');
            const fsLabelWrap = facetEl.querySelector('.fs-label-wrap');
            const fsArrow = facetEl.querySelector('.fs-arrow');

            if (!fsLabelWrap || !fsArrow) return;

            // Check if facet has an active selection
            const hasSelection = FWP.facets[facetName] && FWP.facets[facetName].length > 0;

            // Remove any existing reset button first
            const existingReset = fsLabelWrap.querySelector('.fselect-reset-btn');
            if (existingReset) {
                existingReset.remove();
            }

            if (hasSelection) {
                // Hide the arrow
                fsArrow.style.display = 'none';

                // Create and add reset button
                const resetBtn = document.createElement('button');
                resetBtn.type = 'button';
                resetBtn.className = 'fselect-reset-btn';
                resetBtn.innerHTML = '<span class="sr-only">Reset</span>';
                resetBtn.setAttribute('aria-label', 'Reset ' + facetName);
                resetBtn.setAttribute('data-facet', facetName);

                resetBtn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    FWP.reset(this.getAttribute('data-facet'));
                });

                fsLabelWrap.appendChild(resetBtn);
            } else {
                // Show the arrow when no selection
                fsArrow.style.display = '';
            }
        });
    });

};